<template>
  <div class="wallet theme-group-3">
    <app-page-wrapper-grid class="wallet__grid">
      <div class="wallet__container"></div>
      <!-- Back button -->
      <div class="iw-layout-grid__row p-l-16 p-b-8 p-t-24">
        <div class="iw-layout-grid__col--span-12">
          <back-button />
        </div>
      </div>

      <!-- Form -->
      <div class="iw-layout-grid__row p-16">
        <div class="iw-layout-grid__col--span-4 iw-layout-grid__col--offset-4-desktop">
          <h3 class="iw-page-title m-b-40">Wallet</h3>
          <div
            v-if="(!getSavedCreditCards && !getSavedCards) || (getSavedCreditCards.length === 0 && getSavedCards.length === 0)"
            class="d-flex flex-space-between"
          >
            <img src="@/assets/images/info-icon.svg" />
            <p class="wallet-text">
              {{ message }}
            </p>
          </div>

          <user-credit-card
            v-for="cc in getSavedCreditCards"
            :key="cc.token"
            :card-holder="cc.holder"
            :expiration="cc.expiration"
            :last-four="cc.last4"
            :token="cc.token"
            :gateway-id="cc.gateway_id"
            :show-radio="false"
            :show-delete="true"
            @cardDeleted="cardDeleted"
          />
          <hr
            v-if="getSavedCreditCards && getSavedCards && getSavedCreditCards.length > 0 && getSavedCards.length > 0"
            class="divider"
          />
          <user-credit-card
            v-for="cc in getSavedCards"
            :key="cc.token"
            :card-holder="cc.holder"
            :expiration="cc.expiration"
            :last-four="cc.last4"
            :token="cc.token"
            :gateway-id="cc.gateway_id"
            :show-radio="false"
            :show-delete="true"
            @cardDeleted="cardDeleted"
          />
        </div>
      </div>
    </app-page-wrapper-grid>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BackButton from "@/components/buttons/back-button/BackButton";
import UserCreditCard from "../../../checkout/components/UserCreditCard.vue";
import { ELAVON_GATEWAY_ID, EMPTY_WALLET_MSG, FREEDOMPAY_GATEWAY_ID } from "../../../../../app-constants";
import { CAMPUS_SUBPAYMENT_TYPES } from "@appetize/iw-common/constants";

export default {
  name: "Wallet",
  components: {
    BackButton,
    UserCreditCard
  },
  data() {
    return {
      message: EMPTY_WALLET_MSG
    };
  },
  async mounted() {
    await this.fetchVisitorCards();
  },
  computed: {
    ...mapGetters({ getVisitorCreditCards: "user/getVisitorCreditCards" }),
    getSavedCreditCards() {
      if (!this.getVisitorCreditCards) return [];
      return this.getVisitorCreditCards?.filter(
        (value) => parseInt(value.gateway_id) === ELAVON_GATEWAY_ID || parseInt(value.gateway_id) === FREEDOMPAY_GATEWAY_ID
      );
    },
    getSavedCards() {
      if (!this.getVisitorCreditCards) return [];
      return this.getVisitorCreditCards?.filter((value) => CAMPUS_SUBPAYMENT_TYPES.includes(parseInt(value.gateway_id)));
    }
  },
  methods: {
    ...mapActions({ fetchVisitorCards: "user/fetchVisitorCreditCards" }),
    async cardDeleted() {
      await this.fetchVisitorCards();
    }
  }
};
</script>
<style scoped lang="scss">
.error {
  text-transform: uppercase;
  color: $error-color;
  margin: 0 0 10px 0;
  padding: 1em 1em;
  font-size: 0.5em;
}

.wallet {
  &__title {
    width: 100%;
    text-align: left;
  }

  &__error {
    padding-left: 16px;
    width: calc(100% - 16px);
  }
}
.wallet-text {
  margin: 0 0 0 0.5rem;
}

.divider {
  border-top: 1px gray;
  width: calc(100% - 2px);
  margin: 30px 0;
}
</style>
